export default "__VITE_ASSET__74d62d87__"